module.exports = "/_next/static/images/bike-97bd6bada80e89e367089aeaec89e03b.svg";